import BillingEntitiesService from "@/api/services/billingEntities";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
  },
  mutations: {
    setIndex(state, index) {
      state.index = index;
    },
  },
  actions: {
    async fetchIndex({ commit }, { perPage = null, includes = [] } = {}) {
      const response = await BillingEntitiesService.fetchBillingEntities({
        perPage,
        includes,
      });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data.billingEntities);
      return data.billingEntities;
    },
  },
};
